export var Pointers;
(function (Pointers) {
    Pointers[Pointers["Timeline"] = 0] = "Timeline";
    Pointers[Pointers["Selection"] = 1] = "Selection";
    Pointers[Pointers["PianoMode"] = 2] = "PianoMode";
    Pointers[Pointers["User"] = 3] = "User";
    Pointers[Pointers["AudioConnection"] = 4] = "AudioConnection";
    Pointers[Pointers["InstrumentHost"] = 5] = "InstrumentHost";
    Pointers[Pointers["AudioOutput"] = 6] = "AudioOutput";
    Pointers[Pointers["Capture"] = 7] = "Capture";
    Pointers[Pointers["NotesConnection"] = 8] = "NotesConnection";
    Pointers[Pointers["VoltageConnection"] = 9] = "VoltageConnection";
    Pointers[Pointers["AudioUnits"] = 10] = "AudioUnits";
    Pointers[Pointers["MidiEffectHost"] = 11] = "MidiEffectHost";
    Pointers[Pointers["AudioEffectHost"] = 12] = "AudioEffectHost";
    Pointers[Pointers["AudioBusses"] = 13] = "AudioBusses";
    Pointers[Pointers["AuxSend"] = 14] = "AuxSend";
    Pointers[Pointers["FileUploadState"] = 15] = "FileUploadState";
    Pointers[Pointers["Modulation"] = 16] = "Modulation";
    Pointers[Pointers["Automation"] = 17] = "Automation";
    Pointers[Pointers["Parameter"] = 18] = "Parameter";
    Pointers[Pointers["ParameterController"] = 19] = "ParameterController";
    Pointers[Pointers["MidiControl"] = 20] = "MidiControl";
    Pointers[Pointers["StepAutomation"] = 21] = "StepAutomation";
    Pointers[Pointers["Editing"] = 22] = "Editing";
    Pointers[Pointers["AudioFile"] = 23] = "AudioFile";
    Pointers[Pointers["SoundfontFile"] = 24] = "SoundfontFile";
    Pointers[Pointers["AudioUnit"] = 25] = "AudioUnit";
    Pointers[Pointers["MarkerTrack"] = 26] = "MarkerTrack";
    Pointers[Pointers["MarkerEvents"] = 27] = "MarkerEvents";
    Pointers[Pointers["ClipCollection"] = 28] = "ClipCollection";
    Pointers[Pointers["RegionCollection"] = 29] = "RegionCollection";
    Pointers[Pointers["TrackCollection"] = 30] = "TrackCollection";
    Pointers[Pointers["Device"] = 31] = "Device";
    Pointers[Pointers["MIDIDevice"] = 32] = "MIDIDevice";
    Pointers[Pointers["Groove"] = 33] = "Groove";
    Pointers[Pointers["ModularSetup"] = 34] = "ModularSetup";
    Pointers[Pointers["ModuleCollection"] = 35] = "ModuleCollection";
    Pointers[Pointers["ConnectionCollection"] = 36] = "ConnectionCollection";
    Pointers[Pointers["DeviceUserInterface"] = 37] = "DeviceUserInterface";
    Pointers[Pointers["NoteEvents"] = 38] = "NoteEvents";
    Pointers[Pointers["NoteEventFeature"] = 39] = "NoteEventFeature";
    Pointers[Pointers["NoteEventCollection"] = 40] = "NoteEventCollection";
    Pointers[Pointers["ValueEvents"] = 41] = "ValueEvents";
    Pointers[Pointers["ValueEventCollection"] = 42] = "ValueEventCollection";
    Pointers[Pointers["ValueInterpolation"] = 43] = "ValueInterpolation";
    Pointers[Pointers["Sample"] = 44] = "Sample";
})(Pointers || (Pointers = {}));
